const DEFAULT_CHUNK_SIZE = 100;
const LOAD_AHEAD_PX = 300;

// Jspreadsheet's built-in lazy loader creates every row up front and then
// removes rows that are above the viewport. This loader keeps the worksheet
// data itself incremental and only appends the next batch when needed.
export function installAppendOnlyRowLoading(worksheet, options = {}) {
  const content = worksheet && worksheet.content;
  const remainingRows = options.remainingRows || [];
  const appendRows = options.appendRows;

  if (!content || !Array.isArray(remainingRows) || typeof appendRows !== "function") {
    return () => {};
  }

  const chunkSize = options.chunkSize || DEFAULT_CHUNK_SIZE;
  let nextRow = 0;

  // Prevent jspreadsheet's own scroll handler from replacing this append-only
  // behaviour after the initial batch has been created.
  worksheet.options.lazyLoading = false;

  const loadNextChunk = () => {
    if (nextRow >= remainingRows.length) return false;
    const chunk = remainingRows.slice(nextRow, nextRow + chunkSize);
    nextRow += chunk.length;
    appendRows(chunk);
    return chunk.length > 0;
  };

  const onScroll = () => {
    while (
      nextRow < remainingRows.length
      && content.scrollTop + content.clientHeight + LOAD_AHEAD_PX >= content.scrollHeight
    ) {
      if (!loadNextChunk()) break;
    }
  };

  content.addEventListener("scroll", onScroll, { passive: true });

  return () => {
    content.removeEventListener("scroll", onScroll);
  };
}
